"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox3Tree = void 0;
var React = require("react");
var inputComponents_1 = require("../editableList/inputComponents");
var Checkbox3Tree = function (props) {
    return (React.createElement("ul", { className: "Checkbox3Tree" }, props.nodes.map(function (node) {
        return React.createElement("li", null,
            React.createElement(inputComponents_1.Checkbox3, { checked: node.checked, indeterminate: node.indeterminate, value: node.value, disabled: node.disabled, className: node.className, id: node.id, name: node.name, labelText: node.labelText, onChange: node.onChange }),
            node.childNodes &&
                React.createElement(exports.Checkbox3Tree, { nodes: node.childNodes }));
    })));
};
exports.Checkbox3Tree = Checkbox3Tree;
